import React, { useRef, useCallback } from "react";
import { adData } from "../config/constants";
import { mobile } from "../utilities/detection";

export const AdContext = React.createContext();

export default function AdProvider({ children }) {
  const leaderDivs = useRef({});
  leaderDivs.current = (mobile ? adData.divIds.leader.mobile : adData.divIds.leader.desktop).reduce((leaders, id) => {
    const divElement = document.createElement("div");
    divElement.id = id;
    return { ...leaders, [id]: { div: divElement, created: false } };
  }, {});

  const skyLeftDiv = useRef(mobile ? null : document.createElement("div"));
  const skyRightDiv = useRef(mobile ? null : document.createElement("div"));
  const billboardDiv = useRef(mobile ? null : document.createElement("div"));
  const adhesionDiv = useRef(mobile ? document.createElement("div") : null);

  const skyLeftCreated = useRef(false);
  const skyRightCreated = useRef(false);
  const billboardCreated = useRef(false);
  const adhesionCreated = useRef(false);

  if (!mobile) {
    skyLeftDiv.current.id = adData.divIds.sky.left;
    skyRightDiv.current.id = adData.divIds.sky.right;
    billboardDiv.current.id = adData.divIds.billboard;
  } else {
    adhesionDiv.current.id = adData.divIds.adhesion;
  }

  const handleCallback = useCallback((node) => {
    if (node) {
      const container = node; // lint: no assignment to properties of function parameters

      Object.values(leaderDivs.current).forEach((leaderObj) => {
        const leaderObject = leaderObj;
        const { div: leaderDiv } = leaderObject;
        if (!leaderObject.created) {
          container.id = `${leaderDiv.id}-container`;
          container.appendChild(leaderDiv);
          leaderObject.created = true;
        }
      });

      if (!skyLeftCreated.current && !mobile) {
        container.id = `${skyLeftDiv.current.id}-container`;
        container.appendChild(skyLeftDiv.current);
        skyLeftCreated.current = true;
      }

      if (!skyRightCreated.current && !mobile) {
        container.id = `${skyRightDiv.current.id}-container`;
        container.appendChild(skyRightDiv.current);
        skyRightCreated.current = true;
      }

      if (!billboardCreated.current && !mobile) {
        container.id = `${billboardDiv.current.id}-container`;
        container.appendChild(billboardDiv.current);
        billboardCreated.current = true;
      }

      if (!adhesionCreated.current && mobile) {
        container.id = `${adhesionDiv.current.id}-container`;
        container.appendChild(adhesionDiv.current);
        adhesionCreated.current = true;
      }
    }
  }, []);

  return (
    <AdContext.Provider
      value={{
        leaderDivs: leaderDivs.current,
        skyLeftDiv: skyLeftDiv.current,
        skyRightDiv: skyRightDiv.current,
        billboardDiv: billboardDiv.current,
        adhesionDiv: adhesionDiv.current,
        skyLeftCreated,
        skyRightCreated,
        billboardCreated,
        adhesionCreated,
      }}
    >
      {children}
      <div
        id="adrender"
        ref={handleCallback}
        style={{
          position: "absolute",
          top: "-9999px",
          left: "-9999px",
          width: 0,
          height: 0,
        }}
      />
    </AdContext.Provider>
  );
}
